export default "__VITE_ASSET__CkhSQ2A6__"